import {
  PersonalGameStatistics,
  ProjectGameStatisticsItem,
} from '@/stores/GameStatisticsStore/GameStatisticsStore.types';

export const gameStatisticsMocks: PersonalGameStatistics = {
  energyMultiplier: 400,
  energyRechargers: 200,
  incomePerHour: 40,
  activeGems: 2000000,
  passiveGems: 100000,
  improvements: 2312110,
  improvementUpgrades: 100,
  gifts: 500,
  tasks: 10,
  dailyGames: 5,
  tickets: 30,
  energySpent: 1000,
  energyRechargersSpent: 30,
  gemsSpent: 2000000000,
  leagueProgress: [
    {
      periodNumber: 1,
      rank: 5,
      league: {
        from: 0,
        to: 1,
      },
    },
    {
      periodNumber: 2,
      rank: 12,
      league: {
        from: 1,
        to: 1,
      },
    },
    {
      periodNumber: 3,
      rank: 37,
      league: {
        from: 1,
        to: 0,
      },
    },
    {
      periodNumber: 4,
      rank: 2,
      league: {
        from: 0,
        to: 1,
      },
    },
  ],
};

export const projectListMocks: ProjectGameStatisticsItem[] = [
  {
    id: 'totalEnergyRechargers',
    name: 'Сколько заработано батареек',
    value: '1,52 ТРЛН.',
  },
  {
    id: 'spentEnergyRechargers',
    name: 'Сколько потрачено батареек',
    value: '10 ТЫС.',
  },
];
